module.exports = __webpack_public_path__ + "img/H000020_mushroom.383f76b4.png";